"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Commander Spellbook API
 * API for Commander Spellbook, the combo database engine for Magic: The Gathering
 *
 * The version of the OpenAPI document: 4.8.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfCardUsedInVariantSuggestion = instanceOfCardUsedInVariantSuggestion;
exports.CardUsedInVariantSuggestionFromJSON = CardUsedInVariantSuggestionFromJSON;
exports.CardUsedInVariantSuggestionFromJSONTyped = CardUsedInVariantSuggestionFromJSONTyped;
exports.CardUsedInVariantSuggestionToJSON = CardUsedInVariantSuggestionToJSON;
exports.CardUsedInVariantSuggestionToJSONTyped = CardUsedInVariantSuggestionToJSONTyped;
const zoneLocationsEnum_1 = require("./zoneLocationsEnum");
/**
 * Check if a given object implements the CardUsedInVariantSuggestion interface.
 */
function instanceOfCardUsedInVariantSuggestion(value) {
    if (!('card' in value) || value['card'] === undefined)
        return false;
    if (!('quantity' in value) || value['quantity'] === undefined)
        return false;
    if (!('zoneLocations' in value) || value['zoneLocations'] === undefined)
        return false;
    if (!('battlefieldCardState' in value) || value['battlefieldCardState'] === undefined)
        return false;
    if (!('exileCardState' in value) || value['exileCardState'] === undefined)
        return false;
    if (!('libraryCardState' in value) || value['libraryCardState'] === undefined)
        return false;
    if (!('graveyardCardState' in value) || value['graveyardCardState'] === undefined)
        return false;
    if (!('mustBeCommander' in value) || value['mustBeCommander'] === undefined)
        return false;
    return true;
}
function CardUsedInVariantSuggestionFromJSON(json) {
    return CardUsedInVariantSuggestionFromJSONTyped(json, false);
}
function CardUsedInVariantSuggestionFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'card': json['card'],
        'quantity': json['quantity'],
        'zoneLocations': (json['zoneLocations'].map(zoneLocationsEnum_1.ZoneLocationsEnumFromJSON)),
        'battlefieldCardState': json['battlefieldCardState'],
        'exileCardState': json['exileCardState'],
        'libraryCardState': json['libraryCardState'],
        'graveyardCardState': json['graveyardCardState'],
        'mustBeCommander': json['mustBeCommander'],
    };
}
function CardUsedInVariantSuggestionToJSON(json) {
    return CardUsedInVariantSuggestionToJSONTyped(json, false);
}
function CardUsedInVariantSuggestionToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'card': value['card'],
        'quantity': value['quantity'],
        'zoneLocations': (value['zoneLocations'].map(zoneLocationsEnum_1.ZoneLocationsEnumToJSON)),
        'battlefieldCardState': value['battlefieldCardState'],
        'exileCardState': value['exileCardState'],
        'libraryCardState': value['libraryCardState'],
        'graveyardCardState': value['graveyardCardState'],
        'mustBeCommander': value['mustBeCommander'],
    };
}
//# sourceMappingURL=cardUsedInVariantSuggestion.js.map